import { InjectionToken } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { NotificationModel } from './models/notification';

export const NOTIFICATION = new InjectionToken<ReplaySubject<NotificationModel>>('NOTIFICATION');
export const NOTIFICATION_FN = () => new ReplaySubject<NotificationModel>();
